import styled from 'styled-components/macro';

export const OptionsWrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 100%;
`;
